import { useApi } from "../contexts/api";

const BASE_URL = "/waybe/chatbot";

export function criarChatbotService({ get, post, put }) {
  async function buscarDisponibilidade() {
    try {
      const response = await get(`${BASE_URL}/disponibilidade`);
      return response?.data?.disponivel === true;
    } catch (error) {
      return false;
    }
  }

  async function enviarPergunta({ question, conversationId, messageIds }) {
    const response = await post(`${BASE_URL}/conversas/mensagens`, {
      question,
      conversationId,
      messageIds,
    });
    return response.data;
  }

  async function avaliarConversa({ conversationId, resolvido, nota, comentario }) {
    await post(`${BASE_URL}/avaliacoes`, { conversationId, resolvido, nota, comentario });
  }

  async function listarAvaliacoes(parametros) {
    const response = await get(`${BASE_URL}/avaliacoes?${parametros}`);
    return response.data;
  }

  async function buscarRelatorioAvaliacoes(parametros) {
    const response = await get(`${BASE_URL}/avaliacoes/relatorio?${parametros}`);
    return response.data;
  }

  async function buscarEmpresasAvaliadas() {
    const response = await get(`${BASE_URL}/avaliacoes/empresas`);
    return response.data ?? [];
  }

  async function exportarAvaliacoes(parametros) {
    return get(`${BASE_URL}/avaliacoes/exportar?${parametros}`, false, { responseType: "blob" });
  }

  async function buscarConfiguracao() {
    try {
      const response = await get(`${BASE_URL}/configuracao`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async function cadastrarConfiguracao(dto) {
    const response = await post(`${BASE_URL}/configuracao`, dto);
    return response.data;
  }

  async function atualizarConfiguracao(dto) {
    const response = await put(`${BASE_URL}/configuracao`, dto);
    return response.data;
  }

  return {
    buscarDisponibilidade,
    enviarPergunta,
    avaliarConversa,
    listarAvaliacoes,
    buscarRelatorioAvaliacoes,
    buscarEmpresasAvaliadas,
    exportarAvaliacoes,
    buscarConfiguracao,
    cadastrarConfiguracao,
    atualizarConfiguracao,
  };
}

export const useChatbotService = () => criarChatbotService(useApi());
